module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_vm._v("PART IV")])]), _vm._v(" "), _c('p', {
    staticClass: "chap-title-2"
  }, [_c('span', [_vm._v("OTIS SKEDADDLES")])]), _vm._v(" "), _c('p', {
    staticClass: "normal-a"
  }, [_c('i', [_vm._v("The swift thought came to him that the generals did not know what they were about. It was all a trap")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('span', [_vm._v("—S"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("TEPHEN")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANE")]), _vm._v(", "), _c('i', [_vm._v("T"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("HE")]), _vm._v(" R"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ED")]), _vm._v(" B"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ADGE OF")]), _vm._v(" C"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OURAGE")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-36b01b2a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/part4chapter01.vue
// module id = 105
// module chunks = 0